import { createReducer } from "@reduxjs/toolkit";
import { createContext } from "react";
import moment from "moment";
import { getUser } from "../../../../utils";
export const TaxContexts = createContext();
let user = getUser();
export const initState = {
  filter: {
    date_from: moment(),
    date_to: moment(),
    branch: user ? user.branch_code : "",
    branch_name: user ? user.branch_name : "",
    query: "",
    page: 1,
    limit: 10,
    buyer_type: "",
  },

  taxInfo: {
    tax_title: "",
    tax_year: "",
    company_name: "บริษัท เลกาซี่ คอร์ป จำกัด",
    company_address: "",
    company_tax: "0105557129609",
    account_code: "2307001",
    account_name: "ณัฐชนก ห้าวเหิม",
    sheet_name: "",
    file_name: "",
    tax_list: [],
  },

  previewImportModal: {
    visible: false,
  },
  modalImportStatus: {
    visible: false,
  },
};
export const reducer = createReducer(initState, {
  setFilter: (state, { payload }) => {
    state.filter = { ...state.filter, ...payload };
  },
  setTaxInfo: (state, { payload }) => {
    state.taxInfo = { ...state.taxInfo, ...payload };
  },
  setPreviewImportModal: (state, { payload }) => {
    state.previewImportModal = { ...state.previewImportModal, ...payload };
  },
  setModalImportStatus: (state, { payload }) => {
    state.modalImportStatus = { ...state.modalImportStatus, ...payload };
  },

  clearTaxInfo: (state) => {
    state.taxInfo = {
      tax_title: "",
      tax_year: "",
      company_name: "บริษัท เลกาซี่ คอร์ป จำกัด",
      company_address: "",
      company_tax: "0105557129609",
      account_code: "2307001",
      account_name: "ณัฐชนก ห้าวเหิม",
      sheet_name: "",
      file_name: "",
      tax_list: [],
    };
  },
});
export default TaxContexts;
